import styled from 'styled-components';
import { Drawer } from '@material-ui/core';
import { SECONDARY } from '../../shared/styles/colors';

export const Wrapper = styled(Drawer)`
	& > .MuiPaper-root {
		border-left: 5px solid ${SECONDARY}
	}
`;
